import { IMediaFileInfo } from 'AppTypes'

export class MediaFileInfo implements IMediaFileInfo {
  id: string

  originalName: string

  fileSize: number

  presignedUrlKey: string

  constructor (id: string, originalName: string, fileSize: number, presignedUrlKey: string) {
    this.id = id
    this.originalName = originalName
    this.fileSize = fileSize
    this.presignedUrlKey = presignedUrlKey
  }
}
